import { LineTable } from './LineTable';

export type { TypeLineTableProps } from './types';
export default LineTable;
